import { FC } from 'react';
import { I18nextProvider } from 'react-i18next';
import { type I18nextProviderProps } from 'react-i18next';

export const I18nPdfProvider: FC<I18nextProviderProps> = ({ i18n, children }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
);
